import { useCallback, useEffect, useState } from 'react';
import { useShallowEqualSelector } from '../../utils/reduxUtils';
import { useDispatch } from 'react-redux';
import { ChargebacksActions } from './actions';
import { Filter } from '@increasecard/typed-components';
import { filtersToParams } from '../../utils/filtersUtils';
import Constants from '../../constants';
import { useCurrency, useEventTracker } from '@increasecard/increase-core';
import { getDateRangeFiltersFormatted } from '@card/commonlib';

export interface UseChargebacksDataOptions {
  filters: Record<string, Filter>;
  dateRangeInput: Date[];
}

export function useChargebacksData({ filters, dateRangeInput }: UseChargebacksDataOptions) {
  const tracker = useEventTracker();
  const dispatch = useDispatch();
  const list = useShallowEqualSelector((s) => s.chargebacks.list);
  const currency = useCurrency();
  const [currentCurrency, setCurrentCurrency] = useState<string>(currency || 'ARS');

  const setPage = useCallback(
    (page: number) => {
      const filtersFormatted = filtersToParams(filters);
      const dateRangeFiltersFormatted = getDateRangeFiltersFormatted(dateRangeInput);
      dispatch(
        ChargebacksActions.fetchStarted({
          pagination: { page },
          filters: {
            ...filtersFormatted,
            daterange: dateRangeFiltersFormatted,
            currency: currentCurrency
          }
        })
      );
    },
    [dispatch, filters, dateRangeInput, currentCurrency]
  );

  const handleCreateReport = () => {
    // eslint-disable-next-line @typescript-eslint/camelcase
    tracker.track('Generate report', { report_type: 'chargebacks' });
    const filtersFormatted = filtersToParams(filters);
    const dateRangeFiltersFormatted = getDateRangeFiltersFormatted(dateRangeInput);
    dispatch(
      ChargebacksActions.generateReportStarted({
        pagination: { page: list.settings.current_page },
        filters: {
          ...filtersFormatted,
          daterange: dateRangeFiltersFormatted,
          currency: currentCurrency
        }
      })
    );
  };

  useEffect(() => {
    setPage(Constants.FIRST_PAGE);
  }, [setPage]);

  return { list, setPage, currentCurrency, setCurrentCurrency, handleCreateReport };
}
